// @ts-strict-ignore
export const updateMonacoActiveState = ({ editor, isActiveRef }) => {
  // When there are multiple LiquidInput(Monaco Editor) on the same page, auto completion is being
  // triggered for all inputs, which causes duplication in the suggestion menu.
  // We update the isActive state of the current input to only trigger auto completion on the active one.
  if (editor) {
    editor.onDidFocusEditorWidget(() => {
      isActiveRef.current = true;
    });
    editor.onDidBlurEditorWidget(() => {
      isActiveRef.current = false;
    });
  }
};
